/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCast = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 4v16h20V4H2zm2 14v-2.9c1.4.4 2.5 1.5 2.9 2.9H4zm4.9 0c-.4-2.5-2.4-4.5-4.9-4.9v-2c3.6.5 6.5 3.3 6.9 6.9h-2zM20 18h-7c-.5-4.7-4.2-8.5-9-9V6h16v12z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCast as Cast };
